import { Component, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { CheckWinningsRepositoryService } from "../check-winnings-repository.service";
import { IonicModule } from "@ionic/angular";
import { LottieComponent } from "ngx-lottie";
@Component({
    selector: "app-surprise-gift",
    standalone: true,
    templateUrl: "./surprise-gift.component.html",
    styleUrl: "./surprise-gift.component.scss",
    imports: [
        IonicModule,
        LottieComponent,
        TranslatePipe,
    ],
})
export class SurpriseGiftComponent {
  public creditAmountDvString: string;
  private isAnimating = false;
  sanitizedUrl: string;
  private unsubscribeAll$ = new Subject<void>();
  constructor(
    public elementRef: ElementRef,
    private authService: AuthService,
    private translate: TranslateService,
    private checkWinningsService: CheckWinningsRepositoryService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    if (this.router.url.includes("/surprise-gift")) {
       this.activeRoute.queryParams.subscribe(params => {
        const checkNo = params['check_no'];
        const checkPrize = params['check_prize'];  
        const sanitizedCheckNo = encodeURIComponent(checkNo);
        const sanitizedCheckPrize = encodeURIComponent(checkPrize);
        this.sanitizedUrl = `checkWinnings?check_no=${sanitizedCheckNo}&check_prize=${sanitizedCheckPrize}`;
      });  
    }
    this.authService?.selectedlanguage$.pipe(takeUntil(this.unsubscribeAll$))?.subscribe(
      (l) => {
        if (l) {
          this.translate.use(l ? l : "en");
        }
      },
      (err) => {
        this.translate.use("en");
        return err;
      }
    );

    const currentWinningDoc = this.checkWinningsService.surpriseAnimationDocument;
    if (currentWinningDoc) {
      const currentDvString = this.transformString(currentWinningDoc);
      this.creditAmountDvString = currentDvString;
      authService
        .getDVFromString(currentDvString)
        .then((res: string) => {
          this.creditAmountDvString = res;
        })
        .catch((err) => {
          return err;
        });
    }
  }

  private transformString(inputString: string): string {
    // Split the incoming string by '_'
    const parts = inputString.split("_");

    // Extract the number from the second part
    const numberPart = parts?.[0];

    // Return the formatted string
    return `[currency_beautify:${numberPart}]`;
  }

  ionViewWillLeave() {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  // Removed the existing the spine animation & implemented new lottie animation
  animationInitiate(): void {
    const navigationUrl = this.sanitizedUrl;
    setTimeout(() => {
      this.router.navigateByUrl(navigationUrl)
    }, 7500);
  }
}
